import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Package, Layers, ImageIcon } from "lucide-react";
import { Product, ProductVariant } from "@/types/product-type";

interface MockStore {
  id: string;
  name: string;
}

interface ProductOverviewProps {
  product: Product;
  productVariants: ProductVariant[];
  store: MockStore;
}

export function ProductOverview({
  product,
  productVariants,
  store,
}: ProductOverviewProps) {
  const getStatusColor = (isActive: boolean | null | undefined) => {
    return isActive ? "default" : "secondary";
  };

  return (
    <Card>
      <CardHeader className="pb-4">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Product Overview</CardTitle>
            <CardDescription>
              {product.description || "No description provided"}
            </CardDescription>
          </div>
          <Badge variant={getStatusColor(product.isActive)}>
            {product.isActive ? "Active" : "Inactive"}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid gap-6 md:grid-cols-4">
          <div className="flex items-center space-x-3">
            <Package className="h-4 w-4 text-muted-foreground" />
            <div>
              <span className="text-sm text-muted-foreground">Store</span>
              <p className="font-medium">{store.name}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <Layers className="h-4 w-4 text-muted-foreground" />
            <div>
              <span className="text-sm text-muted-foreground">Variants</span>
              <p className="font-medium">{productVariants.length}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <ImageIcon className="h-4 w-4 text-muted-foreground" />
            <div>
              <span className="text-sm text-muted-foreground">Price</span>
              <p className="font-medium">${product.price.toFixed(2)}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div>
              <span className="text-sm text-muted-foreground">Created</span>
              <p className="font-medium">
                {product.createdAt
                  ? new Date(product.createdAt).toLocaleDateString()
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
